import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";
import { addTermsAndConditionsURL } from "../../../utils/urls";

const TermsConditionsSetup = () => {
    const [content, setContent] = useState('');

    const handleSave = async () => {
        try {
            const response = await makeRequest2(addTermsAndConditionsURL, "POST", { content });

            if (response.success) {
                toastify("Terms & Conditions saved successfully", "success");
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            console.error("Error saving terms:", err);
            toastify("Error saving Terms & Conditions", "error");
        }
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
        ],
    };

    return (
        <div className="container my-5" style={{ maxWidth: "90%" }}>
            <Card title="Terms & Conditions Setup" className="shadow-sm border-0">
                <ReactQuill
                    value={content}
                    onChange={setContent}
                    modules={modules}
                    theme="snow"
                    style={{ height: "300px", marginBottom: "60px" }}
                />
                <Button
                    label="Save Terms & Conditions"
                    icon="pi pi-save"
                    severity="primary"
                    onClick={handleSave}
                />
            </Card>
        </div>
    );
};

export default TermsConditionsSetup;
